// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { truncateAtWordBoundary } from 'utils/truncate';
import { useSectionId } from 'utils/hooks/use-section-id';

export interface LandingpageTextProps {
  headline: string;
  subline: string;
  text: string;
  contentIndex: number;
  titleInAnchor: boolean;
  isSectionReference?: boolean;
}

export function LandingpageText({
  headline,
  subline,
  text,
  contentIndex,
  titleInAnchor,
  isSectionReference,
  ...content
}: Readonly<LandingpageTextProps>) {
  const backgroundColor = content['background-color'];
  const truncatedHeadline = truncateAtWordBoundary(headline, 77);
  const truncatedSubline = truncateAtWordBoundary(subline, 107);
  const truncatedText = truncateAtWordBoundary(text, 1000);
  const sectionId = useSectionId(headline, '', titleInAnchor, contentIndex);

  return (
    <div className={`c-landingpage-text c-landingpage-text--${backgroundColor}`} id={sectionId}>
      <div className="grid-container c-landingpage-text__content">
        {truncatedHeadline && (
          <InnerHtml
            as="h2"
            content={truncatedHeadline}
            previewId="#st_headline"
            isSectionReference={isSectionReference}
          />
        )}
        {truncatedSubline && (
          <InnerHtml
            as="h3"
            content={truncatedSubline}
            previewId="#st_subline"
            isSectionReference={isSectionReference}
          />
        )}
        {truncatedText && (
          <InnerHtml
            as="p"
            content={truncatedText}
            previewId="#st_text"
            isSectionReference={isSectionReference}
          />
        )}
      </div>
    </div>
  );
}
